import axios from 'axios';

import { NEXT_PUBLIC_AUTH0_CLIENT_ID, NEXT_PUBLIC_AUTH0_DOMAIN } from '@/env';

const api = {
  resetPassword: async (email: string): Promise<string> => {
    const res = await axios.request({
      method: `POST`,
      url: `https://${NEXT_PUBLIC_AUTH0_DOMAIN}/dbconnections/change_password`,
      headers: { 'content-type': `application/json` },
      data: {
        client_id: NEXT_PUBLIC_AUTH0_CLIENT_ID,
        email: email,
        connection: `Username-Password-Authentication`,
      },
    });

    return res.data;
  },
};

export default api;
